/**
 * @todo Implémenter l'accessibilité : https://www.w3.org/TR/wai-aria-practices-1.1/examples/tabs/tabs-2/tabs.html
 */

(function ($) {
  /**
   * Find each carousel and trigger their size recalculation.
   * 
   * @param {object jQuery} $content The active tab content.
   */
  function trigger_slider_update_size_in_content($content) {
    // FLICKITY
    $content.find('.flickity-enabled').each(function () {
      $(this).find('.swiper-slide').each(function () {
        $(this).css('height', 'auto'); // S'il reste à 100%, ça empêche le resize de bien trouver la taille.
      });
      window.requestAnimationFrame(function () {
        $(this).flickity('resize');
      }.bind(this));
    });

    // SWIPER
    $content.find('.swiper-container-initialized').each(function () {
      this.swiper.update();
    });
  }
  function save_tab_id_in_local_storage(id) {
    localStorage.activeTabId = id;
  }
  function get_active_content_from_url() {
    return $(window.location.hash);
  }
  function get_active_content() {
    var $active_content = get_active_content_from_url();

    // 1. Check for hashtag.
    if ($active_content.length) {
      // BAIL with URL hashtag if present.
      return $active_content;
    }

    // 2. Check for localStorage.
    if ('undefined' !== typeof localStorage.activeTabId) {
      // BAIL with localStorage if it exists.
      return $("#".concat(localStorage.activeTabId));
    }

    // 3. No globally saved active tab. Signal failure by giving an empty jQuery object,
    return $();
  }
  function activate_globally_saved_content() {
    get_active_content().addClass('active');
  }
  function activate_tab_by_trigger($trigger) {
    var $content = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    var push_state = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    var content_id = $trigger.attr('aria-controls');
    if (null === $content) {
      $content = $("#".concat(content_id));
    }

    // Remove old active tab
    $trigger.parents('.vtx-tabs-nav').find('.vtx-tabs-nav__trigger.active').removeClass('active').attr('aria-selected', false);
    $content.parents('.vtx-tabs').find('.vtx-tab-item.active').removeClass('active');

    // Activate new tab
    $trigger.addClass('active').attr('aria-selected', true);
    $content.addClass('active');
    if (push_state) {
      save_tab_id_in_local_storage(content_id);

      // Add # to URL
      if (history.pushState) {
        history.pushState(null, null, '#' + content_id);
      } else {
        window.location.hash = '#' + content_id;
      }
    }
    window.requestAnimationFrame(function () {
      trigger_slider_update_size_in_content(this); // this === $content
    }.bind($content));
  }

  ///// ON READY /////
  $(function () {
    // Set the globally saved active content.
    activate_globally_saved_content();

    // Prepare all tabs.
    $('.vtx-tabs').each(function () {
      var $contents = $(this).find('.vtx-tab-item');
      var $active_content = $contents.filter('.active').first();
      if (!$active_content.length) {
        $active_content = $contents.first();
      }

      // Activate a tab on load
      if ($active_content.length) {
        activate_tab_by_trigger($('[aria-controls="' + $active_content.attr('id') + '"]'), $active_content, false);
      }
    });

    // Set click event
    $('.vtx-tabs-nav__trigger').on('click', function () {
      activate_tab_by_trigger($(this));
    });
  });
})(jQuery);